import { useTranslation } from 'react-i18next';
import { notificationService } from '@/lib/services/notification.service';
import { logger } from '@/lib/utils/logger';
import { CreateMcpCatalogDto } from '@inference.engine/api-client/web';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { createMcpCatalog } from '../../api/mcp-catalog.api';
import { ADMIN_QUERY_KEYS } from '../../api';

export const useCreateCatalogMcp = () => {
  const { t } = useTranslation('admin');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ body }: { body: CreateMcpCatalogDto }) => createMcpCatalog(body),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ADMIN_QUERY_KEYS.mcpCatalog.available });
      // Catalog edits also surface in the user-facing MCP views (My MCPs + chat composer), which
      // read a separate `['user-mcps', …]` query namespace. Admin must not import the
      // user-mcp-servers feature (FSD boundary), so invalidate by its stable root prefix.
      await queryClient.invalidateQueries({ queryKey: ['user-mcps'] });
      notificationService.showSuccess(t('admin.useCreateCatalogMcp.mcpServerAddedToThe'));
    },
    onError: (error) => {
      notificationService.showError(t('admin.useCreateCatalogMcp.failedToAddMcpServerTo'));
      logger.error('Failed to create catalog MCP:', error);
    },
  });
};
